import { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import HomePage from '../Home'
import { AppBar } from '@material-ui/core'
// import PaquetesMayorista from '../PaquetesMayorista'
import VPaquetes from '../Paquetes/VPaquetes'
import VProveedorTerrestre from '../ProveedoresTerrestres/VProveedoresTerrestres'
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `wrapped-tab-${index}`,
        'aria-controls': `wrapped-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
}))
export default function PaqueteMain() {
    const classes = useStyles();
    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <div className={classes.root}>
                <AppBar position="static" color='transparent'>
                    <Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
                        <Tab
                            value={0}
                            label="Paquetes proveedor"
                            wrapped
                            {...a11yProps('one')}
                        />
                        <Tab
                            value={1}
                            label="Paquetes mayorista"
                            wrapped
                            {...a11yProps('one')}
                        />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <VPaquetes />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {/* <PaquetesMayorista /> */}
                    <VProveedorTerrestre />
                </TabPanel>
            </div>
        </HomePage>
    )
}
